import { Capacitor } from '@capacitor/core';
import { NativeBiometric } from '@capgo/capacitor-native-biometric';

export const platform = Capacitor.getPlatform();
const isMobileApp = platform === 'ios' || platform === 'android';

export const registerBiometrics = async (username: string | null | undefined, password: string | undefined) => {
    if (!isMobileApp) {
        return false;
    }
    const result = await NativeBiometric.isAvailable();

    if (!result.isAvailable) return;
    const verified = await NativeBiometric.verifyIdentity()
        .then(() => true)
        .catch(() => false);

    if (!verified) return;

    const credsSet = NativeBiometric.setCredentials({
        username: username ?? '',
        password: password ?? '',
        server: 'app.paytron.com.au',
    })
        .then(() => true)
        .catch(() => false);

    if (!credsSet) return false;
};

export const checkBiometrics = async () => {
    if (!isMobileApp) {
        return false;
    }
    const result = await NativeBiometric.isAvailable();
    if (!result.isAvailable) return false;
    const credentials = await NativeBiometric.getCredentials({
        server: 'app.paytron.com.au',
    });
    if (!credentials) return false;
    return true;
};

export const getBiometricsType = async () => {
    try {
        const biometrics = await checkBiometrics();
        if (!biometrics)
            return {
                biometricsAvailable: false,
                biometricOption: null,
            };
        const result = await NativeBiometric.isAvailable();

        let biometricOption: string | null = '';

        const bioType = result?.biometryType;

        if (bioType === 0) {
            biometricOption = null;
        } else if (bioType === 1) {
            biometricOption = 'Touch ID';
        } else if (bioType === 2) {
            biometricOption = 'Face ID';
        } else if (bioType === 3) {
            biometricOption = 'Fingerprint scan';
        } else if (bioType === 4) {
            biometricOption = 'Iris scan';
        } else if (bioType === 5) {
            biometricOption = 'Biometric scan';
        }

        return {
            biometricsAvailable: bioType > 0, // NOTE: zero means no biometric is available
            biometricOption,
        };
    } catch (e) {
        return {
            biometricsAvailable: false,
            biometricOption: null,
        };
    }
};

export const getBiometrics = async () => {
    const verified = await NativeBiometric.verifyIdentity()
        .then(() => true)
        .catch(() => false);
    if (!verified) return;

    const result = await NativeBiometric.getCredentials({
        server: 'app.paytron.com.au',
    });

    return result;
};
